import {
  CircularProgress,
  CircularProgressLabel,
  Image,
  Text,
  VStack,
} from "@chakra-ui/react"

import greenArrowIcon from "#/assets/arrow-green.svg"
import { selectDepositAmount, useDappSelector } from "#/redux-state"

import DepositModalDivider from "./DepositModalDivider"

export default function DepositModalIncoming() {
  const depositAmount = useDappSelector(selectDepositAmount)

  return (
    <VStack>
      <CircularProgress
        size="140px"
        thickness="4px"
        color="green.highlight"
        trackColor="primary.white.100"
        isIndeterminate
      >
        <CircularProgressLabel
          display="flex"
          w="100%"
          h="100%"
          justifyContent="center"
          alignItems="center"
        >
          <Image src={greenArrowIcon} w="88px" h="88px" />
        </CircularProgressLabel>
      </CircularProgress>
      <VStack gap={0}>
        <Text variant="numbersL" color="green.highlight">
          {depositAmount} BTC
        </Text>
        <Text
          variant="body"
          color="green.highlight"
          fontWeight={500}
          fontFamily="riforma.medium"
          lineHeight={0}
          mt={1}
        >
          incoming...
        </Text>
      </VStack>
      <DepositModalDivider />
      <Text
        variant="body"
        fontWeight={500}
        fontFamily="riforma.medium"
        color="#0D1014"
      >
        You can close this window now.
      </Text>
    </VStack>
  )
}
